import { render, staticRenderFns } from "./informacionedicion_permisovacacion.vue?vue&type=template&id=2b1b5ca1"
import script from "./informacionedicion_permisovacacion.vue?vue&type=script&lang=js"
export * from "./informacionedicion_permisovacacion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports